import { Link } from 'react-router-dom';

export default function MenuLink({ label, to, icon, openNewTab = false, lucide, onClick }) {

    const handleClick = (e, target) => {

        if(onClick){
            onClick();
        }

        if (openNewTab) {
            e.preventDefault();
            window.open(target, '_blank', 'noopener,noreferrer');
        }
    }

    const LucideIcon = () =>{
        return(
            <div className="size-8 m-auto flex items-center justify-center">
                {lucide}
            </div>
        )
    }

    return (
        <Link to={to} onClick={(e) => handleClick(e, to)} className="relative flex w-60 h-12 justify-end items-center overflow-hidden group">
            <div className="absolute inset-0 border border-light-green box-content rounded-full" />
            <div className="absolute top-0 left-0 bg-light-green h-12 w-12 flex rounded-full group-hover:w-full duration-300">
                {icon ?
                    <img className="size-8 m-auto" alt="icone" src={icon}></img> :
                    <LucideIcon/>
                }
            </div>
            <p className="text-dark-green font-medium mr-3 pl-10 whitespace-normal text-right">{label}</p>
        </Link>
    )
}